export enum PermissionClaim {
  RequestContact = 'RequestContact',
  DiscoverContact = 'DiscoverContact',
  DiscoverIamRole = 'DiscoverIamRole',
  CustomerOnboardingMutating = 'CustomerOnboardingMutating',
  ReadMaintenance = 'ReadMaintenance',
  ScheduleMaintenance = 'ScheduleMaintenance',
  ReadCapabilityManagement = 'ReadCapabilityManagement',
  ReadSiteHealthAndStatus = 'ReadSiteHealthAndStatus',
  ReadContactIdentifyingInformation = 'ReadContactIdentifyingInformation',
  ReadSiteAntennaMetrics = 'ReadSiteAntennaMetrics',
  ScheduleReturnToService = 'ScheduleReturnToService',
  ScheduleRTS = 'ScheduleRTS',
  ReadReturnToService = 'ReadReturnToService',
  CustomerOnboardingValidation = 'CustomerOnboardingValidation',
  GsDevOpsAgentRead = 'GsDevOpsAgentRead',
  GsDevOpsAgentChat = 'GsDevOpsAgentChat',
  ReadInventory = 'ReadInventory',
  WriteInventory = 'WriteInventory',
  ManageInventory = 'ManageInventory',
}
